<template>
  <van-row id="index">
    <!-- header part -->
    <myheader></myheader>

    <!-- banner part -->
    <mybanner></mybanner>

    <!-- grid part -->
    <van-skeleton avatar avatar-shape="square" :row="0" id="skeleton-grid-square" :loading="sloading">
      <van-grid clickable :column-num="2" :gutter="0" :border="false">
        <van-grid-item :url="item.url" v-for="(item,index) in studentChildrens" :key="item.id">
          <van-image :src="item.cover" />
        </van-grid-item>
      </van-grid>
    </van-skeleton>


    <!-- forum part -->
    <van-skeleton avatar avatar-shape="square" :row="0" id="skeleton-grid-square2" :loading="sloading">
      <van-tabs>
        <van-tab title="校园新闻">
          <van-list
            v-if="articles0.length > 0"
            :v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            :immediate-check="false"
            style="padding: 0.5rem;"
          >
            <van-card
              v-for="(item,index) in articles0" :key="item.id"
              :title="item.title"
              class="goods-card"
              :thumb="item.coverUrl"
              @click="openDetails(item.id)"
            >
              <template #footer>
                <van-icon name="clock-o" color="#cccccc"> {{item.createTime}} </van-icon>
              </template>
            </van-card>
          </van-list>
          <van-empty v-else description="暂无记录" />
        </van-tab>
        <van-tab title="通知公告">
          <van-list
            v-if="articles2.length > 0"
            :v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            :immediate-check="false"
            style="padding: 0.5rem;"
          >
            <van-card
              v-for="(item,index) in articles2" :key="item.id"
              :title="item.title"
              class="goods-card"
              :thumb="item.coverUrl"
              @click="openDetails(item.id)"
            >
              <template #footer>
                <van-icon name="clock-o" color="#cccccc"> {{item.createTime}} </van-icon>
              </template>
            </van-card>
          </van-list>
          <van-empty v-else description="暂无记录" />
        </van-tab>
      </van-tabs>
    </van-skeleton>

    <van-skeleton avatar avatar-shape="square" :row="0" id="skeleton-grid-square2" :loading="sloading">
      <van-image :src="adBanner.coverUrl" style="margin: 0 0.5rem;" id="adBanner"/>
    </van-skeleton>

    <van-divider>图说校园</van-divider>
    <van-skeleton avatar avatar-shape="square" :row="0" id="skeleton-grid-square2" :loading="sloading">
      <van-grid :clickable="true" :column-num="3" :gutter="0" :border="true" id="showPic">
        <van-grid-item :url="item.url" v-for="(item,index) in articles9" :key="item.id">
          <van-image :src="item.coverUrl" />
        </van-grid-item>
      </van-grid>
    </van-skeleton>

    <van-skeleton avatar avatar-shape="square" :row="0" id="skeleton-grid-square2" :loading="sloading">
      <van-tabs >
        <van-tab title="教学科研">
          <van-list
            v-if="articles5.length > 0"
            :v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            :immediate-check="false"
            style="padding: 0.5rem;"
          >
            <van-card
              v-for="(item,index) in articles5" :key="item.id"
              :title="item.title"
              class="goods-card"
              :thumb="item.coverUrl"
              @click="openDetails(item.id)"
            >
              <template #footer>
                <van-icon name="clock-o" color="#cccccc"> {{item.createTime}} </van-icon>
              </template>
            </van-card>
          </van-list>
          <van-empty v-else description="暂无记录" />
        </van-tab>
        <van-tab title="社团活动">
          <van-list
            v-if="articles6.length > 0"
            :v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            :immediate-check="false"
            style="padding: 0.5rem;"
          >
            <van-card
              v-for="(item,index) in articles6" :key="item.id"
              :title="item.title"
              class="goods-card"
              :thumb="item.coverUrl"
              @click="openDetails(item.id)"
            >
              <template #footer>
                <van-icon name="clock-o" color="#cccccc"> {{item.createTime}} </van-icon>
              </template>
            </van-card>
          </van-list>
          <van-empty v-else description="暂无记录" />
        </van-tab>
        <van-tab title="党建园地">
          <van-list
            v-if="articles7.length > 0"
            :v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            :immediate-check="false"
            style="padding: 0.5rem;"
          >
            <van-card
              v-for="(item,index) in articles7" :key="item.id"
              :title="item.title"
              class="goods-card"
              :thumb="item.coverUrl"
              @click="openDetails(item.id)"
            >
              <template #footer>
                <van-icon name="clock-o" color="#cccccc"> {{item.createTime}} </van-icon>
              </template>
            </van-card>
          </van-list>
          <van-empty v-else description="暂无记录" />
        </van-tab>
      </van-tabs>
    </van-skeleton>


    <!-- footer part -->
    <myfooter></myfooter>

  </van-row>
</template>

<script>
import header from '@/view/header/header'
import banner from '@/view/banner/banner'
import footer from '@/view/footer/footer'

const axios = require('axios')

export default {
  name: 'index',
  components: {
    'myheader' : header,
    'mybanner' : banner,
    'myfooter' : footer
  },
  data () {
    return {
      category_childrens: [],
      category_all: [],
      category_01: [],
      category_02: [],
      category_03: [],
      category_04: [],
      category_05: [],
      category_06: [],
      category_num: [],
      sloading: true,
      categorys: [],
      articles: null,
      articles0: [{}],
      articles1: [{}],
      articles2: [{}],
      articles3: [{}],
      articles4: [{}],
      articles5: [{}],
      articles6: [{}],
      articles7: [{}],
      articles8: [{}],
      articles9: [{}],
      articlesSjkt: null,
      category1: null,
      category2: null,
      category3: null,
      category4: null,
      category5: null,
      category6: null,
      category7: null,
      category8: null,
      category9: null,
      studentChildrens: null,
      detailUrl: '/article/details/',
      categoryUrl: '/article/category/',
      adBanner: [{}],
      friendlink: [{}],
      istop: true,
      loading: false,
      finished: false,
    }
  },
  mounted() {
    let that = this
    // 首页栏目列表
    axios.get(that.global.apiUrl + '/web/channel/listAll')
      .then(function (response) {
        // console.log(response.data.data)
        if (response.data.success && response.data.data.length > 0) {
          // 读取所有栏目一级和二级
          for(var i=0; i<response.data.data.length; i++) {
            that.category_all.push(response.data.data[i])
            if(response.data.data[i].children) {
              for(var j=0; j<response.data.data[i].children.length; j++) {
                 that.category_all.push(response.data.data[i].children[j])
              }
            }
          }

          // console.log(that.category_all)
          // 分析栏目
          // 获取所有num>0的栏目列表
          // for(var index in that.category_all) {
          //   if(that.category_all[index].num > 0) {
          //     that.category_num.push(that.category_all[index])
          //   }
          // }
          // 以num字段排序0-6
          // that.category_num.sort(function(a, b){
          //   var x = a["num"]
          //   var y = b["num"]
          //   return x - y
          // })

          that.sloading = false
          // console.log(that.category_num)

          that.categorys = response.data.data

          for (var index in that.categorys) {
            // 新闻动态
            if (that.categorys[index].code == 'news') {
              for (var n in that.categorys[index].children) {
                // 校园新闻
                if (that.categorys[index].children[n].code == 'schoolnews') {
                  that.category1 = that.categorys[index].children[n]
                }
                // 通知公告
                if (that.categorys[index].children[n].code == 'notice') {
                  that.category2 = that.categorys[index].children[n]
                }
              }
            }

            // 精品专业
            if (that.categorys[index].code == 'major') {
              that.category3 = that.categorys[index]
              that.studentChildrens = that.categorys[index].children
              for (var i in that.studentChildrens) {
                const item = that.studentChildrens[i]
                item.cover = that.global.apiUrl + '/file/getImgStream?idFile=' + item.img
                item.url = that.categoryUrl + item.id
              }
              // console.log(that.category3)
            }

            //
            if (that.categorys[index].code == 'teacher') {
              for (var n in that.categorys[index].children) {
                // 实景课堂
                // if(that.categorys[index].children[n].code == 'jxky') {
                //   that.category4 = that.categorys[index].children[n]
                // }

                // 教学科研
                if (that.categorys[index].children[n].code == 'jxky') {
                  that.category5 = that.categorys[index].children[n]
                }
              }
            }

            // 菁菁校园
            if (that.categorys[index].code == 'student') {
              for (var n in that.categorys[index].children) {
                // 社团活动
                if (that.categorys[index].children[n].code == 'stusthd') {
                  that.category6 = that.categorys[index].children[n]
                }
                // 优秀毕业生
                if (that.categorys[index].children[n].code == 'stuyxbys') {
                  that.category8 = that.categorys[index].children[n]
                }
                // 图说校园
                if (that.categorys[index].children[n].code == 'stutsxy') {
                  that.category9 = that.categorys[index].children[n]
                }
              }
            }


            // 党建工作
            if (that.categorys[index].code == 'party') {
              for (var n in that.categorys[index].children) {
                // 党建园地
                if (that.categorys[index].children[n].code == 'partynews') {
                  that.category7 = that.categorys[index].children[n]
                }
              }
            }

          }

          // console.log(that.category1)
          // 校园动态
          axios.get(that.global.apiUrl + '/web/article/list?page=1&limit=5&idChannel=' + that.category1.id + '&sort=id&order=desc')
            .then(function (response) {
              // console.log(response.data.data.records)
              if (response.data.success && response.data.data.records.length > 0) {
                that.articles0 = response.data.data.records
                for (var index in that.articles0) {
                  const item = that.articles0[index]
                  item.digest = item.title
                  item.title = item.title.length > 36 ? item.title.substring(0, 36) + '...' : item.title
                  item.coverUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + item.img
                }
              }
            })
          axios.get(that.global.apiUrl + '/web/article/list?page=1&limit=14&idChannel=' + that.category1.id + '&sort=id&order=desc')
            .then(function (response) {
              // console.log(response.data.data.records)
              if (response.data.success && response.data.data.records.length > 0) {
                that.articles1 = response.data.data.records
                for (var index in that.articles1) {
                  const item = that.articles1[index]
                  item.digest = item.title
                  item.title = item.title.length > 28 ? item.title.substring(0, 28) + '...' : item.title
                }
              }
            })

          // 通知公告
          axios.get(that.global.apiUrl + '/web/article/list?page=1&limit=9&idChannel=' + that.category2.id + '&sort=id&order=desc')
            .then(function (response) {
              if (response.data.success && response.data.data.records.length > 0) {
                that.articles2 = response.data.data.records
                for (var index in that.articles2) {
                  const item = that.articles2[index]
                  item.digest = item.title
                  item.title = item.title.length > 28 ? item.title.substring(0, 28) + '...' : item.title
                  item.coverUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + item.img
                }
                // 设置tab为鼠标悬停切换
                // $("#clothingnav1 a").mousemove(function (e) {
                //         $(this).tab('show');
                //  });
              }
            })

          // 教学科研
          axios.get(that.global.apiUrl + '/web/article/list?page=1&limit=3&idChannel=' + that.category5.id + '&sort=id&order=desc')
            .then(function (response) {
              if (response.data.success && response.data.data.records.length > 0) {
                that.articles5 = response.data.data.records
                for (var index in that.articles5) {
                  const item = that.articles5[index]
                  item.digest = item.title
                  item.title = item.title.length > 36 ? item.title.substring(0, 36) + '...' : item.title
                  item.coverUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + item.img
                }
              }
            })

          // 社团活动
          axios.get(that.global.apiUrl + '/web/article/list?page=1&limit=3&idChannel=' + that.category6.id + '&sort=id&order=desc')
            .then(function (response) {
              if (response.data.success && response.data.data.records.length > 0) {
                that.articles6 = response.data.data.records
                for (var index in that.articles6) {
                  const item = that.articles6[index]
                  item.digest = item.title
                  item.title = item.title.length > 36 ? item.title.substring(0, 36) + '...' : item.title
                  item.coverUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + item.img
                }
              }
            })

          // 党建园地
          axios.get(that.global.apiUrl + '/web/article/list?page=1&limit=3&idChannel=' + that.category7.id + '&sort=id&order=desc')
            .then(function (response) {
              if (response.data.success && response.data.data.records.length > 0) {
                that.articles7 = response.data.data.records
                for (var index in that.articles7) {
                  const item = that.articles7[index]
                  item.digest = item.title
                  item.title = item.title.length > 36 ? item.title.substring(0, 36) + '...' : item.title
                  item.coverUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + item.img
                }
              }
            })

          // 图说校园
          axios.get(that.global.apiUrl + '/web/article/list?page=1&limit=9&idChannel=' + that.category9.id + '&sort=id&order=desc')
            .then(function (response) {
              if (response.data.success && response.data.data.records.length > 0) {
                that.articles9 = response.data.data.records
                for (var index in that.articles9) {
                  const item = that.articles9[index]
                  item.digest = item.title
                  item.title = item.title.length > 30 ? item.title.substring(0, 30) + '...' : item.title
                  item.coverUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + item.img
                  item.url = that.detailUrl + item.id
                }
              }
            })


        }
      }
    )

    // 获取adBanner
    this.getAdBanner()
  },
  methods: {
    getAdBanner: function () {
      var that = this
      axios.get(that.global.apiUrl + '/web/banner/queryAllByType?type=indexad')
        .then(function (response) {
          if (response.data.success && response.data.data.length > 0) {
            that.adBanner = response.data.data[0]
            that.adBanner.coverUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + that.adBanner.idFile
          }
        })
    },
    // 打开详情页
    openDetails (id) {
      this.$router.push({ path:'/article/details/'+id })
      // window.location.href = "/article/details/"+id
    }

  }
}
</script>

<style>
#index {
  padding-top: 3.4rem;
}
#skeleton-grid-square .van-skeleton__avatar {
  width: 100%;
  height: 20rem;
  margin-top: 1rem;
}
#skeleton-grid-square2 .van-skeleton__avatar {
  width: 100%;
  height: 8rem;
  margin-top: 1rem;
}
.van-grid-item__content {
  padding: 0.4rem;
}
#showPic .van-image__img {
  width: 7rem;
  height: 5rem;
}
#adBanner img {
    width: 100%;
    height: 3.5rem;
}
</style>



// WEBPACK FOOTER //
// src/view/index/index.vue